import React from "react";
import { Card, Descriptions, Tag } from "antd";
import { CronStatus } from "../../types/crawlerHealth";

interface CronStatusCardProps {
  cron: CronStatus | null;
  loading?: boolean;
}

function formatNextRunAt(nextRunAt: string | null): string {
  if (!nextRunAt) return "N/A";
  const date = new Date(nextRunAt);
  return date.toLocaleString();
}

export const CronStatusCard: React.FC<CronStatusCardProps> = ({
  cron,
  loading,
}) => {
  return (
    <Card title="Cron Schedule" loading={loading}>
      {cron ? (
        <Descriptions column={1} size="small">
          <Descriptions.Item label="Status">
            {cron.enabled ? (
              <Tag color="green">Enabled</Tag>
            ) : (
              <Tag color="red">Disabled</Tag>
            )}
          </Descriptions.Item>
          <Descriptions.Item label="Interval">
            Every {cron.intervalHours}h
          </Descriptions.Item>
          <Descriptions.Item label="Next Run">
            {formatNextRunAt(cron.nextRunAt)}
          </Descriptions.Item>
        </Descriptions>
      ) : (
        <span>No data</span>
      )}
    </Card>
  );
};
